import styled from 'styled-components';

export const PlayOverviewWrapper = styled.div`
  position: relative;

  display: flex;
  padding: 8px 12px 0 12px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: 20px;
`;

export const PlayOverviewTextWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  overflow: hidden;
`;

export const PlayOverviewHeader = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.textColorHeading};
`;

export const PlayOverviewSubHeader = styled.div`
  font-weight: 300;
  color: ${({ theme }) => theme.textColor};
`;

export const PlayOverviewLogo = styled.a.attrs((props) => ({
  href: props.href,
  target: '_blank',
}))`
  position: relative;
  display: flex;
  flex: 0 0 32px;

  path {
    fill: ${({ theme }) => theme.logoFill};
    fill-rule: evenodd;
  }
`;

export const PlayOverviewTooltip = styled.div`
  position: absolute;
  left: 12px;
  top: 8px;
  width: calc(100% - 48px);
  padding: 12px;
  box-shadow: 1px 12px 35px -6px ${({ theme }) => theme.tooltipShadowColor};
  // Intentionally background
  background: ${(props) => props.theme.tooltipBackground};
  border-radius: 6px;
  z-index: 1000;
`;
